/* eslint-disable no-return-assign */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Alert from 'react-s-alert';
import _ from 'lodash';
import { connect } from 'react-redux';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import Select from 'react-select';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function RePrintHealthCert({ data, showTransaction, id }) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    business_establishment_id:
      _.get(data, 'included.businessEstablishments[0].id') || '',
  });
  const validateForm = useFormValidator(formData, {
    business_establishment_id: 'required',
  });

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    showTransaction(id);
  };

  const token = get('token') || '';

  const authProfile = getJson('profile') || '';

  const onChangeSelect = (key) => (item) => {
    setFormData({
      ...formData,
      [key]: _.get(item, 'value'),
    });
  };

  const onGenerate = (e) => {
    e.preventDefault();
    if (!_.get(formData, 'business_establishment_id')) {
      return Alert.warning('Business Establishment field is required');
    }

    const src = `${process.env.REACT_APP_WS}${c.HEALTH_CERTIFICATE_URI}${_.get(
      data,
      'id'
    )}/regenerate?bearer_token=${token}&business_establishment_id=${_.get(
      formData,
      'business_establishment_id'
    )}&email=${_.get(authProfile, 'email')}`;
    window.location.href = src;

    setModal({ isOpen: false });
    return showTransaction(id);
  };

  const options =
    _.get(data, 'included.businessEstablishments').map((item) => {
      return {
        label: _.get(item, 'attributes.name'),
        value: _.get(item, 'id'),
        fullInfo: _.get(item, 'attributes'),
      };
    }) || [];

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <div className="row">
            <div className="col-12 ">
              <div className="form-input-group">
                <label className="form-control-plaintext">
                  Business Establishment to Print{' '}
                  {validateForm.renderMessage('business_establishment_id')}
                </label>
                <Select
                  value={
                    options.find(
                      (item) =>
                        _.get(item, 'value') ===
                        _.get(formData, 'business_establishment_id')
                    ) || {}
                  }
                  onChange={onChangeSelect('business_establishment_id')}
                  options={options}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <button
          type="button"
          onClick={closeModal}
          className="mt-3 mr-3 btn btn-dark "
        >
          <span className="font-weight-bold">Close</span>
        </button>
        <button
          type="button"
          onClick={onGenerate}
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
          disabled={!validateForm.response.is_passed}
        >
          <span className="font-weight-bold">Generate</span>
        </button>
      </div>
    </Modal.Body>
  );
}

RePrintHealthCert.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(RePrintHealthCert);
